module.exports = __webpack_public_path__ + "static/media/money.dc637b07.png";